export default __webpack_public_path__ + "static/media/zootodo_001.2102d4c0.gif";